export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  const isLocalDevelopment =
    import.meta.env.DEV ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  // En développement local, un ancien service worker peut servir
  // des fichiers mis en cache et masquer les dernières modifications.
  // On le désactive donc sur localhost. Il reste actif en production.
  if (isLocalDevelopment) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(
          registrations.map((registration) => registration.unregister())
        )
      )
      .catch(() => {});

    if ('caches' in window) {
      caches
        .keys()
        .then((keys) =>
          Promise.all(
            keys
              .filter((key) => key.toLowerCase().includes('le-defi'))
              .map((key) => caches.delete(key))
          )
        )
        .catch(() => {});
    }

    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('Service worker non enregistré :', error);
    });
  });
}
